import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { ThemeProvider } from '@mui/material/styles';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './index.css';

import graphqlClient from './graphql';
import theme from './conf/theme';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ErrorPage from './components/errorPage/ErrorPage';
import menuItems from './navigation/appMenu/menuItems';
import Login from './features/auth/Login';
import ProtectedRoute from './util/protectedRoute';
import EmailVerification from './features/auth/EmailVerification';
import EmailVerified from './features/auth/EmailVerified';
import Registration from './features/auth/Registration';
import ForgotPassword from './features/auth/ForgotPassword';

const router = createBrowserRouter([
  {
    path: '/login',
    element: <Login />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/email',
    element: <EmailVerification />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/forgotPassword',
    element: <ForgotPassword />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/registration',
    element: <Registration />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/completeRegistration',
    element: <EmailVerified />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <App />
      </ProtectedRoute>
    ),
    errorElement: <ErrorPage />,
    children: menuItems.map((menuItem) => {
      return { path: menuItem.path, element: menuItem.page };
    }),
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <ApolloProvider client={graphqlClient}>
        <RouterProvider router={router} />
      </ApolloProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
